import { createFileRoute } from "@tanstack/react-router";
import { AngebotEditor } from "@/pages/team/AngebotEditor";

/**
 * Der Angebots-Editor (Angebotstool, 12.09.2026) — Formular links, das
 * Dokument live rechts, Versand und PDF oben. Das `$id_` mit Unterstrich
 * verhindert, dass die Seite in die Akte hineinnestet (die hat kein Outlet).
 */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId")(
	{
		component: AngebotEditorSeite,
	},
);

function AngebotEditorSeite() {
	const { id, angebotId } = Route.useParams();
	return <AngebotEditor id={id} angebotId={angebotId} />;
}
